// extracted by mini-css-extract-plugin
export default {"imageWrapper":"XU-z","hovered":"YU-z","hoverImage":"ZU-z","mainImage":"_U-z","imageNoBackground":"aV-z","fullSizeImage":"bV-z"};